export function isValidEns(ensDomain: string): boolean {
  return ensDomain.includes(".");
}
